<template>
  <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; width: 100%">
    <div class="content">
      <Logo/>
      <div style="text-align: center; margin-bottom: 20px;">
        <Callout/>
      </div>
      <div class="callout">
        <h1>What you need to know about Securities-Based Lending:</h1>
        <p>Securities-based lending (SBL) is an innovative way for investors to access liquidity without having to sell
          their investment assets. With SBL, your clients can borrow against the value of their non-retirement
          investment portfolio—such as stocks, bonds, and mutual funds—while continuing to maintain their investment
          strategy.</p>

        <div style="display: flex; justify-content: center; margin-bottom: 20px;">
          <img :src="stock_image_1" alt="Stock Image" style="max-width: 800px;"/>
        </div>

        <h2>How Does Securities-Based Lending Work?</h2>
        <p>Instead of selling investments to cover expenses or access cash (which could disrupt financial plans and
          trigger taxes), SBL lets your clients use their portfolios as collateral for a flexible credit line. This
          process is typically streamlined, with minimal income verification and no need to rebalance the portfolio.</p>

        <h2>Common Uses for SBL:</h2>
        <p>Securities-based lending can provide quick, cost-effective funds for a variety of purposes, including:</p>
        <ul>
          <li>Financing business opportunities or working capital</li>
          <li>Making large purchases or covering major expenses (such as home renovation, wedding, or tuition)</li>
          <li>Consolidating high-interest debt at potentially lower rates</li>
          <li>Paying taxes or covering estate settlement costs</li>
          <li>Managing unexpected expenses or emergencies</li>
        </ul>

        <h2>Key Benefits of Securities-Based Lending:</h2>
        <p><strong>Maintain Your Client’s Investment Strategy:</strong> Your client doesn’t have to sell assets, so
          their long-term plan
          remains intact – and you retain AUM.</p>
        <p><strong>Tax Efficiency:</strong> Avoid triggering taxable events that may occur when liquidating investments.
        </p>
        <p><strong>Lower Interest Rates:</strong> SBL often offers more competitive rates than credit cards or unsecured
          loans.</p>
        <p><strong>Financial Flexibility:</strong> Interest is payable only on the funds that are used, with no
          application or annual fees.</p>
        <p><strong>Streamlined Access:</strong> The application and underwriting process is usually fast and digital,
          with immediate access
          to funds once approved.</p>
        <p><strong>Retain Growth Potential:</strong> Since the portfolio stays invested, your client can continue to
          participate in
          potential market gains.</p>

        <h2>What is the Wealth Lending Network?</h2>
        <p>The Wealth Lending Network is a platform operated by Broadridge that connects financial advisors and wealth
          managers with leading providers of securities-based lending solutions. This means that firms and advisors that
          do not have an affiliated bank can offer SBL to their clients through this network.
          By streamlining the process—from application to funding—the Wealth Lending Network makes it possible for
          advisors of any size to expand their service offerings, enhance client relationships, and provide flexible
          liquidity solutions tailored to diverse client needs. Interested in learning more? Click the 'Start the
          conversation' button to begin.</p>

        <h2>Is SBL Right for You?</h2>
        <p>Securities-based lending is a powerful tool for clients who want to manage both sides of their balance sheet,
          providing a proactive way to handle both investments and short-term liquidity needs. However, it carries
          unique
          risks and is not suitable for everyone. Before using an SBL solution, speak with your lender to understand how
          this strategy fits with your client’s financial goals, and consult with tax and legal professionals for
          specialized guidance.</p>

        <hr style="margin-bottom: 25px;">


        <h2>Have Questions About Lending? We’re Here to Help.</h2>
        <p>You don’t need a client in mind to start the conversation. Our securities-based
          lending specialists are available to answer your questions, provide clarity on the
          product, outline the process, and help set expectations. Whether you're
          gathering information or preparing for future opportunities, we're here to
          support you.</p>

        <hr style="margin-top: 25px;">
        <h3>NOTE</h3>
        <ol>
          <li>The SBL loan cannot be used for the purchase of additional securities or to pay off a margin loan that was
            used to purchase securities.
          </li>
          <li>Minimum requested amount must be $75,000.00 or such greater amount as may be prescribed from time to time
            pursuant to 12 C.F.R. Section 1026.3(b) of Regulation Z issued by the Consumer Financial Protection Bureau
            as the minimum threshold necessary to qualify the Line of Credit as an exempt consumer credit transaction
            thereunder.
          </li>
          <li>Lenders generally do not charge an application fee. State, local and/or third-party fees may apply in some
            states.
          </li>
          <li>Securities-based lending is a powerful tool for clients who want to manage both sides of their balance
            sheet, providing a proactive way to handle both investments and short-term liquidity needs. SBL loans carry
            unique risks and are not suitable for everyone. Before using an SBL solution, speak with your lender to
            understand how this strategy fits with your client’s financial goals, and consult with tax and legal
            professionals for specialized guidance.
          </li>
        </ol>
      </div>
    </div>
    <Footer/>
    <div class="button-container">
      <button type="button" @click="startConversation">
        Start the Conversation
      </button>
    </div>

  </div>
</template>

<script setup>
import stock_image_1 from '@/assets/stock_image_1.jpg';
</script>

<script>
import Logo from "./components/Logo";
import Footer from "./components/Footer";
import Callout from "./components/Callout.vue";


export default {
  components: {
    Logo,
    Footer,
    Callout
  },
  methods: {
    startConversation() {
      const source = this.$route.query.source;
      this.$router.push({name: 'Form', query: {source}});
    }
  }
};
</script>

<style scoped>
h1 {
  margin: 0;
  font-weight: 400;
  line-height: 1.15;
  font-size: 3em;
  color: #001F5A;
}

h2 {
  font-size: 24px;
  margin: 0;
  font-weight: 400;
  line-height: 1.15;
  color: #001F5A;
}

p, ol, ul {
  font-weight: 400;
  line-height: 1.3;
  font-size: 18px;
}

.button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  padding: 16px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}


</style>
